import { useBitcoinPrice, useMempoolInfo } from '@/hooks/useBitcoinBlocks';
import { DollarSign, Activity, Flame } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

export function StatsBar() {
  const { data: price, isLoading: priceLoading } = useBitcoinPrice();
  const { data: mempool, isLoading: mempoolLoading } = useMempoolInfo();
  
  return (
    <div className="bg-card/80 backdrop-blur-sm border-b border-primary/30">
      <div className="container mx-auto px-4 py-3">
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-4 md:gap-8">
          {/* Bitcoin Price */}
          <div className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-primary" />
            <div>
              <div className="text-xs text-muted-foreground">Bitcoin Price</div>
              {priceLoading ? (
                <Skeleton className="h-5 w-24" />
              ) : (
                <div className="font-semibold text-foreground">
                  ${price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              )}
            </div>
          </div>
          
          {/* Mempool Size */}
          <div className="flex items-center gap-2">
            <Activity className="h-5 w-5 text-secondary" />
            <div>
              <div className="text-xs text-muted-foreground">Mempool Size</div>
              {mempoolLoading ? (
                <Skeleton className="h-5 w-20" />
              ) : (
                <div className="font-semibold text-foreground">
                  {(mempool?.vsize ? mempool.vsize / 1000000 : 0).toFixed(2)} MB
                </div>
              )}
            </div>
          </div>
          
          {/* Pending Transactions */}
          <div className="flex items-center gap-2">
            <Flame className="h-5 w-5 text-accent" />
            <div>
              <div className="text-xs text-muted-foreground">Pending Txs</div>
              {mempoolLoading ? (
                <Skeleton className="h-5 w-16" />
              ) : (
                <div className="font-semibold text-foreground">
                  {mempool?.count.toLocaleString()}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
